export class InvestmentsPeriodEventType {

	static UPDATE = 'UPDATE_INVESTMENTS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-period/investments-period.event.type.ts